import { s as makeRestApiRequest } from "./utils2.mjs";

//#region src/api/roles.ts
const getRoles = async (context) => {
	return await makeRestApiRequest(context, "GET", "/roles?withUsageCount=true");
};
const createRole = async (context, body) => {
	return await makeRestApiRequest(context, "POST", "/roles", body);
};
const getRoleBySlug = async (context, body) => {
	return await makeRestApiRequest(context, "GET", `/roles/${body.slug}?withUsageCount=true`);
};
const updateRole = async (context, slug, body) => {
	return await makeRestApiRequest(context, "PATCH", `/roles/${slug}`, body);
};
const deleteRole = async (context, slug, reassignRoleSlug) => {
	return await makeRestApiRequest(context, "DELETE", `/roles/${slug}${reassignRoleSlug ? `?reassignRoleSlug=${encodeURIComponent(reassignRoleSlug)}` : ""}`);
};
const getRoleAssignments = async (context, slug) => {
	return await makeRestApiRequest(context, "GET", `/roles/${slug}/assignments`);
};
const getRoleProjectMembers = async (context, slug, projectId) => {
	return await makeRestApiRequest(context, "GET", `/roles/${slug}/assignments/${projectId}/members`);
};
const getRoleMembers = async (context, slug) => {
	return await makeRestApiRequest(context, "GET", `/roles/${slug}/members`);
};

//#endregion
export { getRoleMembers as a, updateRole as c, getRoleBySlug as i, deleteRole as n, getRoleProjectMembers as o, getRoleAssignments as r, getRoles as s, createRole as t };
//# sourceMappingURL=roles.mjs.map